import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginQueryVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.AdminInput;
}>;


export type LoginQueryResult = (
  { __typename?: 'Query' }
  & { login?: GraphQLTypes.Maybe<(
    { __typename?: 'AdminAuthPayload' }
    & Pick<GraphQLTypes.AdminAuthPayload, 'token' | 'tokenExpiration' | 'firstName' | 'lastName' | 'id'>
    & { permissions?: GraphQLTypes.Maybe<(
      { __typename?: 'AdminPermissions' }
      & Pick<GraphQLTypes.AdminPermissions, 'canHandlePayments'>
    )> }
  )> }
);


export const LoginDocument = /*#__PURE__*/ gql`
    query login($input: AdminInput!) {
  login(input: $input) {
    token
    tokenExpiration
    firstName
    lastName
    id
    permissions {
      canHandlePayments
    }
  }
}
    `;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQueryResult, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginQueryResult, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQueryResult, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginQueryResult, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;